import React, { Component } from 'react'
import './Top.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactTooltip from 'react-tooltip'
import { Trail } from 'react-spring'

const ICON_SIZE = '2x'

class Top extends Component {
  render () {
    const ITEMS = [
      <a rel='noopener noreferrer' key='email_link' target='_blank' href='mailto:iamfrostin@gmail.com' className='icon'> <FontAwesomeIcon key='email' icon='envelope' size={ICON_SIZE} /> </a>,
      <a rel='noopener noreferrer' key='twitter_link' target='_blank' href='https://twitter.com/fr0st1n' className='icon'> <FontAwesomeIcon key='twitter' icon={['fab', 'twitter-square']} size={ICON_SIZE} /> </a>,
      <a rel='noopener noreferrer' key='github_link' target='_blank' href='https://github.com/FR0ST1N' className='icon'> <FontAwesomeIcon key='github' icon={['fab', 'github-square']} size={ICON_SIZE} /> </a>,
      <FontAwesomeIcon key='discord' icon={['fab', 'discord']} size={ICON_SIZE} data-tip='React-tooltip' className='icon' />
    ]
    const KEYS = ['SEmail', 'STwitter', 'SGitHub', 'SDiscord']
    return (
      <div className='main'>
        <Trail
          items={ITEMS}
          keys={KEYS}
          from={{ opacity: 0 }}
          to={{ opacity: 1 }}
          config={{ duration: 1000 }}
        >
          {item => props =>
            <div style={props} className='space'>{item}</div>}
        </Trail>
        <ReactTooltip place='bottom' type='light' effect='solid'>
          <span className='tag'>Frostin#4956</span>
        </ReactTooltip>
      </div>
    )
  }
}

export default Top
